import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import createState from './state';

export default {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions,
};
